/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/12/1
 * @updateTime 2021/12/1
 * @decription 保全预览 =》 解除保全审核信息入口js
 */
// 预览模块
import ccPreviewModule from '@/components/common/preview-module/index.vue';
// 数据转换
import transformData from '@/views/mixins/transform-data.js';
// 代码值
import {typeShjg} from "@/filters";
import codeUtils from "@/utils/code";
export default {
    name: 'app-preservation-preview-jcbq',
    // 混入
    mixins: [transformData],
    // 依赖组件
    components: {
        ccPreviewModule
    },
    // 参数
    props: {
        // 展现数据
        data: Object
    },
    // 数据
    data() {
        return {
            // 展现数据
            displayData: []
        };
    },
    // 计算属性
    computed: {},
    // 监听
    watch: {},
    // 创建完成
    async created() {
        // 创建完成
        // 进行数据转化
        this.displayData = await this.getTransformData(this.data);
    },
    // 方法
    methods: {

        /**
         * 获取转换数据
         * @param {Object} data 源数据
         * @returns {Array<Object>}
         * */
        async getTransformData(data) {
            // 审核状态为2，则说明正在审核中
            if (data.shzt === '2') {
                return [];
            }
            // 解除保全事由代码值map
            const _codeMap = await codeUtils.getCodeMap('306000');
            const _transformItemData = [];
            _transformItemData.push(this.getRowData('审核结果', typeShjg(data.shjg)));
            // 审核不通过，需要显示原因
            data.shjg === '2' && _transformItemData.push(this.getRowData('原因', data.shbtgyy));
            // 审核结果通过，需要显示解除保全事由
            data.shjg === '1' && _transformItemData.push(this.getRowData('解保原因', codeUtils.getKeyName(_codeMap, data.jcyj)));
            _transformItemData.push(this.getRowData('审核日期', data.shrq));
            return [_transformItemData];
        }
    }
};
